module.exports = __webpack_public_path__ + "c520b3a646e1e8515becaba694a055fd.ttf";